import { MAX_LENGTH_TEXTAREA } from '@/configs/constants';
import { cn } from '@/utils/utils';
import React from 'react';

export interface TextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> { }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => {
        return (
            <textarea
                className={cn(
                    'flex min-h-[80px] w-full rounded-base border border-border-input bg-background-input px-3 py-2 text-sm hover:border-primaryWeb ring-offset-background transition-colors duration-300 placeholder:text-placeholder focus-visible:outline-none focus-visible:border-primaryWeb disabled:cursor-not-allowed disabled:bg-disable disabled:hover:border-disable',
                    className
                )}
                maxLength={MAX_LENGTH_TEXTAREA}
                ref={ref}
                {...props}
            />
        );
    }
);
Textarea.displayName = 'Textarea';

export { Textarea };
